/* Dirty South Jukebox — Top Charts board (v3.23.0) */
(function () {
  'use strict';
  function init(root) {
    var songs = [];
    try { songs = JSON.parse(root.querySelector('[data-songs]').textContent || '[]'); } catch (e) { songs = []; }
    songs = songs.map(function (x, i) { x._i = i; return x; }).sort(function (a, b) { return ((a.rank || 9999) - (b.rank || 9999)) || (a._i - b._i); });
    var audio = root.querySelector('[data-audio]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-row]'));
    var nowEl = root.querySelector('[data-now]');
    var idleText = nowEl ? nowEl.textContent : '';
    var playBtn = root.querySelector('[data-act="toggle"]');
    var moreWrap = root.querySelector('[data-more-wrap]');
    var more = root.querySelector('[data-more]');
    var playlistDialog = root.querySelector('[data-playlist-dialog]');
    var playlistSongs = root.querySelector('[data-playlist-songs]');
    var playlistStatus = root.querySelector('[data-playlist-status]');
    var playlistTrigger = root.querySelector('[data-playlist-open]');
    function closePlaylist() { if (playlistDialog && playlistDialog.open) playlistDialog.close(); if (playlistTrigger) playlistTrigger.focus(); }
    if (playlistTrigger && playlistDialog) {
      playlistTrigger.addEventListener('click', function () { playlistDialog.showModal(); });
      root.querySelector('[data-playlist-close]').addEventListener('click', closePlaylist);
      playlistDialog.addEventListener('click', function (e) { var r = playlistDialog.getBoundingClientRect(); if (e.target === playlistDialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) closePlaylist(); });
    }
    function renderPlaylist() {
      if (!playlistSongs) return;
      playlistSongs.replaceChildren();
      songs.slice().sort(function(a,b){return a.title.localeCompare(b.title);}).forEach(function(s){
        var li=document.createElement('li'), button=document.createElement('button'), title=document.createElement('span'), status=document.createElement('small');
        button.type='button'; button.dataset.playlistSong=s.id; button.disabled=false;
        title.textContent=s.title; status.textContent='▶ Play';
        button.append(title,status); li.appendChild(button); playlistSongs.appendChild(li);
      });
    }
    var shop = root.querySelector('[data-shop]');
    var counter = (root.getAttribute('data-counter') || '').replace(/\/+$/, '');
    var order = [];      // full play order: top 10, then the rest alphabetized
    var current = -1;    // index into order
    var pinnedId = null;
    var fails = 0;
    var shareCur = root.querySelector('[data-act="share-current"]');
    var toast = root.querySelector('[data-toast]'), toastT;
    function say(msg) { if (!toast) return; toast.textContent = msg; toast.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 3800); }
    function share(s) {
      if (!s) return;
      var url = location.origin + location.pathname + '?song=' + encodeURIComponent(s.slug);
      var data = { title: s.title + ' \u2014 Dirty South Tease', text: 'Give this one a spin: ' + s.title, url: url };
      if (navigator.share && matchMedia('(pointer: coarse)').matches) { navigator.share(data).catch(function () {}); return; }
      var done = function () { say('Link copied \u2014 "' + s.title + '" will show at #1 for anyone who opens it.'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
      else window.prompt('Copy this link:', url);
    }

    if (!songs.length) { var em = root.querySelector('[data-empty]'); if (em) em.hidden = false; }

    function bySlug(slug) { slug = (slug || '').toLowerCase(); for (var i = 0; i < songs.length; i++) if (songs[i].slug === slug || songs[i].id === slug) return songs[i]; return null; }

    function pinned() {
      var q = null;
      try { q = new URLSearchParams(location.search).get('song'); } catch (e) {}
      if (q) { try { sessionStorage.setItem('dst-chart-pin', q); } catch (e) {} }
      else { try { q = sessionStorage.getItem('dst-chart-pin'); } catch (e) {} }
      var s = bySlug(q); return s ? s.id : null;
    }

    function build(rankIds) {
      var base = songs.slice();
      if (rankIds && rankIds.length) {
        var pos = {}; rankIds.forEach(function (id, i) { pos[id] = i; });
        base.sort(function (a, b) { var pa = a.id in pos ? pos[a.id] : 1e6 + songs.indexOf(a), pb = b.id in pos ? pos[b.id] : 1e6 + songs.indexOf(b); return pa - pb; });
      }
      pinnedId = pinned();
      if (pinnedId) { var p = base.filter(function (s) { return s.id === pinnedId; })[0]; base = [p].concat(base.filter(function (s) { return s.id !== pinnedId; })); }
      var top = base.slice(0, 8);
      var rest = base.slice(8).sort(function (a, b) { return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }); });
      order = top.concat(rest);
      render(top, rest);
    }

    function render(top, rest) {
      rows.forEach(function (li, i) {
        var s = top[i], btn = li.querySelector('.chart-row__btn'), t = li.querySelector('.chart-row__title'), tag = li.querySelector('.chart-row__tag');
        li.classList.toggle('is-empty', !s);
        li.classList.toggle('is-soon', !!(s && !s.src));
        li.classList.toggle('is-pinned', !!(s && s.id === pinnedId));
        var sh = li.querySelector('.chart-row__share');
        if (sh) { sh.hidden = !s; if (s) sh.setAttribute('aria-label', 'Share ' + s.title); }
        if (!s) { t.innerHTML = '&nbsp;'; tag.textContent = ''; btn.disabled = true; btn.removeAttribute('aria-label'); return; }
        t.textContent = s.title;
        li.classList.remove('is-long');
        li.classList.remove('is-xlong');
        tag.textContent = s.level === 'explicit' ? 'E' : '';
        tag.title = s.level === 'explicit' && s.src ? 'Explicit' : '';
        btn.disabled = false;
        btn.setAttribute('aria-label', '#' + (i + 1) + ' ' + s.title + '');
      });
      if (more) {
        while (more.options.length > 1) more.remove(1);
        songs.slice().sort(function (a, b) { return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }); })
          .forEach(function (s) { var o = document.createElement('option'); o.value = s.id; o.textContent = s.title + (s.src ? '' : ' (coming soon)'); o.disabled = !s.src; more.appendChild(o); });
        moreWrap.hidden = songs.length === 0;
      }
      renderPlaylist();
      paint();
    }

    function paint() {
      var playing = !audio.paused && current > -1;
      root.classList.toggle('is-playing', playing);
      rows.forEach(function (li, i) { li.classList.toggle('is-current', i === current); li.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      var s = order[current];
      if (nowEl) nowEl.textContent = s ? s.title : idleText;
      if (playlistSongs) playlistSongs.querySelectorAll('[data-playlist-song]').forEach(function(b) {
        var selected=!!(s && b.dataset.playlistSong===s.id);
        b.classList.toggle('is-current',selected);
        b.setAttribute('aria-pressed',selected && playing ? 'true':'false');
        if (!b.disabled) b.querySelector('small').textContent=selected && playing?'Ⅱ Pause':'▶ Play';
      });
      if (playlistStatus) playlistStatus.textContent=s?(playing?'Now playing: ':'Paused: ')+s.title:'';
      if (more) more.value = s ? s.id : '';
      if (shareCur) shareCur.hidden = !s;
      updateMerch(s || order[0]);
      if (shop) {
        if (s && s.shop) { shop.innerHTML = ''; var a = document.createElement('a'); a.href = s.shop; a.textContent = (s.shopLabel || 'Shop the look'); var lead = document.createElement('span'); lead.textContent = 'Now playing: ' + s.title + ' · '; shop.appendChild(lead); shop.appendChild(a); shop.hidden = false; }
        else shop.hidden = true;
      }
    }

    var merchId;
    function updateMerch(song) {
      if (!song || merchId === song.id) return;
      merchId= song.id;
      var area=root.querySelector('[data-merch-products]'), label=root.querySelector('[data-merch-song]'), empty=root.querySelector('[data-merch-empty]'), collection=root.querySelector('[data-merch-collection]');
      if (!area) return;
      label.textContent=song.title;
      area.replaceChildren();
      var products=song.products || [];
      empty.hidden=products.length > 0;
      empty.textContent='The shirts behind this lil’ diddy will appear here once they’re added.';
      collection.hidden=products.length > 0;
      collection.href=song.shop || '/collections/the-spicy-side';
      products.forEach(function(p){
        var card=document.createElement('div'); card.className='chart-merch__card';
        var link=document.createElement('a'); link.href=p.url; link.target='_blank'; link.rel='noopener'; link.setAttribute('aria-label',p.title+' (opens in a new tab)');
        if(p.image){var image=document.createElement('img'); image.src=p.image; image.alt=p.title; image.width=230; image.height=230; image.loading='lazy'; link.appendChild(image);}
        var title=document.createElement('h3'); title.textContent=p.title; link.appendChild(title); card.appendChild(link);
        var price=document.createElement('p'); price.className='chart-merch__price'; price.textContent=p.price; card.appendChild(price);
        var form=document.createElement('form'), select=document.createElement('select'), button=document.createElement('button');
        select.setAttribute('aria-label','Choose size and color for '+p.title);
        (p.variants || []).forEach(function(v){var option=document.createElement('option'); option.value=v.id; option.textContent=v.title+(v.available?'':' — Sold out'); option.disabled=!v.available; select.appendChild(option);});
        var available=(p.variants || []).filter(function(v){return v.available;});
        if(available.length)select.value=available[0].id;
        button.type='submit'; button.textContent=available.length?'Add to Bag':'Sold Out'; button.disabled=!available.length;
        select.addEventListener('change',function(){var v=p.variants.find(function(v){return String(v.id)===select.value;});if(v)price.textContent=v.price;});
        form.append(select,button); card.appendChild(form); area.appendChild(card);
        form.addEventListener('submit',function(event){
          event.preventDefault(); button.disabled=true; button.textContent='Adding…';
          var status=root.querySelector('[data-merch-status]');status.textContent='';
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:select.value,quantity:1}]})})
          .then(function(r){return r.json().then(function(data){if(!r.ok)throw new Error(data.description || 'Unable to add this shirt. Please try again.');return data;});})
          .then(function(){status.textContent=p.title+' added to your bag. ';var bag=document.createElement('a');bag.href='/cart';bag.textContent='View Bag';status.appendChild(bag);})
          .catch(function(error){status.textContent=error.message || 'Unable to add this shirt. Please try again.';})
          .finally(function(){button.disabled=false;button.textContent='Add to Bag';});
        });
      });
    }
    var giftShare=root.querySelector('[data-share-gift]');
    if(giftShare)giftShare.addEventListener('click',function(){
      var url=new URL(giftShare.dataset.url,location.origin).href;
      var data={title:'Your Own Dirty Little Hit — Dirty South Tease',text:'Turn your story into a one-of-a-kind custom song.',url:url};
      function copied(){say('Custom-song gift link copied.');}
      function copy(){if(navigator.clipboard && navigator.clipboard.writeText)navigator.clipboard.writeText(url).then(copied,function(){window.prompt('Copy this gift idea:',url);});else window.prompt('Copy this gift idea:',url);}
      if(navigator.share)navigator.share(data).catch(function(e){if(e.name!=='AbortError')copy();});else copy();
    });

    function ping(id) {
      if (!counter) return;
      try { var u = counter + '/play?id=' + encodeURIComponent(id); if (navigator.sendBeacon) navigator.sendBeacon(u); else fetch(u, { method: 'POST', keepalive: true, mode: 'no-cors' }); } catch (e) {}
    }

    function play(i) {
      var s = order[i]; if (!s) return;
      if (!s.src) { audio.pause(); current=i; audio.removeAttribute('src'); paint(); say('Audio has not been attached to this track yet.'); return; }
      if (i !== current) { current = i; audio.src = s.src; ping(s.id); }
      var p = audio.play(); if (p && p.catch) p.catch(function () { paint(); });
      paint();
    }
    function step(d) {
      if (!order.length) return;
      var i = current < 0 ? (d > 0 ? -1 : 0) : current;
      for (var n = 0; n < order.length; n++) { i = (i + d + order.length) % order.length; if (order[i].src) return play(i); }
    }
    function toggle() {
      if (current < 0) return step(1);
      if (audio.paused) play(current); else { audio.pause(); paint(); }
    }

    root.addEventListener('click', function (e) {
      var songButton=e.target.closest('[data-playlist-song]');
      if(songButton && !songButton.disabled) {
        var songIndex=order.findIndex(function(s){return s.id===songButton.dataset.playlistSong;});
        if(songIndex===current) toggle(); else play(songIndex);
        return;
      }
      var b = e.target.closest('[data-act]'); if (!b || !root.contains(b)) return;
      var act = b.getAttribute('data-act');
      if (act === 'row') { var i = +b.closest('[data-row]').getAttribute('data-row'); if (i === current) toggle(); else play(i); }
      else if (act === 'share') { var r = +b.closest('[data-row]').getAttribute('data-row'); share(order[r]); }
      else if (act === 'share-current') share(order[current]);
      else if (act === 'toggle') toggle();
      else if (act === 'next') step(1);
      else if (act === 'prev') { if (current > -1 && audio.currentTime > 3) { audio.currentTime = 0; } else step(-1); }
    });
    if (more) more.addEventListener('change', function () { var id = more.value; if (!id) return; for (var i = 0; i < order.length; i++) if (order[i].id === id) return play(i); });
    audio.addEventListener('timeupdate', function () { var li = rows[current]; if (li && audio.duration) li.style.setProperty('--p', (audio.currentTime / audio.duration).toFixed(4)); });
    audio.addEventListener('ended', function () { if (rows[current]) rows[current].style.setProperty('--p', 0); step(1); });
    audio.addEventListener('play', paint); audio.addEventListener('pause', paint);
    audio.addEventListener('error', function () { if (current < 0) return; fails++; if (fails < order.length) step(1); else { fails = 0; audio.removeAttribute('src'); paint(); } });
    audio.addEventListener('playing', function () { fails = 0; });

    // phone: the whole jukebox sits in exactly one screen (between the header and the bottom dock); the chart scrolls inside
    var mq = window.matchMedia('(max-width: 749px)');
    function fit() {
      if (!mq.matches) { root.style.height = ''; return; }
      var top = root.getBoundingClientRect().top + window.scrollY;
      var dock = document.querySelector('.mobile-dock'); var dh = dock && getComputedStyle(dock).display !== 'none' ? dock.offsetHeight : 0;
      root.style.height = '';
    }
    fit(); window.addEventListener('resize', fit); window.addEventListener('orientationchange', fit); window.addEventListener('load', fit);
    build(null);
    if (counter) {
      fetch(counter + '/top', { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.ids && current < 0) build(d.ids); }).catch(function () {});
    }
  }
  function boot() { document.querySelectorAll('[data-chart]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();